import { Theme, ThemeService } from '@agilox/common';
import { Component, computed, inject, OnDestroy, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SpinnerComponent } from '@agilox/ui';
import { shareReplay, switchMap } from 'rxjs';
import { SummaryOfTheYearService } from '@agilox/common';
import { MultipleVehiclesComponent } from './components/multiple-vehicles/multiple-vehicles.component';
import { SingleVehicleComponent } from './components/single-vehicle/single-vehicle.component';

@Component({
	selector: 'summary-of-the-year',
	templateUrl: './summary-of-the-year.component.html',
	imports: [SingleVehicleComponent, MultipleVehiclesComponent, SpinnerComponent],
})
export class SummaryOfTheYearComponent implements OnInit, OnDestroy {
	private readonly service = inject(SummaryOfTheYearService);
	private readonly themeService = inject(ThemeService);

	protected readonly year = this.service.year;
	protected readonly multipleMinimalVehicles = 3;

	vehicles$ = this.service.getVehicles().pipe(shareReplay(1));

	vehicles = toSignal(this.vehicles$, { initialValue: [] });

	data = toSignal(
		this.vehicles$.pipe(
			switchMap((vehicles) => this.service.fetchData(vehicles.map((v) => v.serial)))
		),
		{ initialValue: undefined }
	);
	loading = computed(() => !this.vehicles() || !this.data());

	ngOnInit(): void {
		this.themeService.applyThemeToDom(Theme.LIGHT);
	}

	ngOnDestroy(): void {
		this.themeService.applyThemeToDom(undefined);
	}
}
